import type { FC } from "react";
import { MdFavorite, MdAdd, MdSave, MdHistory, MdSettings } from "react-icons/md";
import { useAppContext, type AppView } from "../contexts/AppContext";

type SidebarView = "folders" | "addFavorites" | "save" | "history" | "settings";

const Sidebar: FC = () => {
    const { currentView, openedProject, navigateToFolders, navigateToAddFavorites, navigateToSave, quickSaveEmails, navigateToHistory, navigateToSettings } = useAppContext();

    const handleArchiveClick = async () => {
        if (openedProject) {
            const saved = await quickSaveEmails(openedProject);
            if (!saved) {
                navigateToSave();
            }
        } else {
            navigateToSave();
        }
    };

    const sidebarItems: Array<{ key: SidebarView; icon: any; title: string; action: () => void }> = [
        { key: "folders", icon: MdFavorite, title: "Favorites", action: navigateToFolders },
        { key: "addFavorites", icon: MdAdd, title: "Add to Favorites", action: navigateToAddFavorites },
        { key: "save", icon: MdSave, title: "Archive Email", action: handleArchiveClick },
        { key: "history", icon: MdHistory, title: "Archive History", action: navigateToHistory },
        { key: "settings", icon: MdSettings, title: "Settings", action: navigateToSettings },
    ];

    return (
        <div className="sidebar">
            {sidebarItems.map((item, index) => {
                const IconComponent = item.icon;
                const isActive = item.key === currentView;
                return (
                    <button key={index} className={isActive ? "sidebar-item active" : "sidebar-item"} onClick={item.action} title={item.title}>
                        <IconComponent />
                    </button>
                );
            })}
        </div>
    );
};

export default Sidebar;
